import React from 'react'

import { StyledTaboolaContainer } from './Ads.styles'

import Script from 'next/script'

const TABOOLA_SCRIPT = `
  window._taboola = window._taboola || [];
  _taboola.push({article:'auto'});
  !function (e, f, u, i) {
    if (!document.getElementById(i)){
      e.async = 1;
      e.src = u;
      e.id = i;
      f.parentNode.insertBefore(e, f);
    } }(document.createElement('script'),
  document.getElementsByTagName('script')[0],
  '//cdn.taboola.com/libtrc/news12optimum-network/loader.js',
  'tb_loader_script');
  if(window.performance && typeof window.performance.mark == 'function')
    {window.performance.mark('tbl_ic');}
`

type TaboolaConfig = {
  mode?: string
  container?: string
  placement?: string
  target_type?: string
}

const alternatingThumbnailsConfig: TaboolaConfig = {
  mode: 'alternating-thumbnails-a',
  container: 'taboola-feed---below-article-thumbnails',
  placement: 'Feed - Below article thumbnails',
  target_type: 'mix'
}

const Taboola = () => {
  return (
    <>
      <Script dangerouslySetInnerHTML={{ __html: TABOOLA_SCRIPT }} />
      <StyledTaboolaContainer data-testid={`taboola-ad`} id={alternatingThumbnailsConfig.container}>
        <Script
          dangerouslySetInnerHTML={{
            __html: `
          window._taboola = window._taboola || [];
          _taboola.push(${JSON.stringify(alternatingThumbnailsConfig)});
          _taboola.push({flush: true});
        `
          }}
        />
      </StyledTaboolaContainer>
    </>
  )
}

export default Taboola
